import Load from 'components/Load';
import NavigationableLayout from 'modules/app/components/NavigationableLayout';
import React from 'react';
import basePath from 'utils/basePath';

const AsyncFeatureFlags = Load(
  () =>
    import(/* webpackChunkName: "feature-flags" */ './components/FeatureFlags'),
  {},
  true,
);

const FeatureFlagRoute = (
  <NavigationableLayout
    path={`${basePath}/feature-flags`}
    component={AsyncFeatureFlags}
    nonFixedNavbar
  />
);

export default FeatureFlagRoute;
